import React, { useMemo } from "react";
import { isArray } from "lodash";

import { useUserRoleSelector } from "../../store";
import { CustomComponent, IRole, IRoleName } from "../../store/types";

interface RoleComponentGuardProps {
  availableRoles: IRoleName | IRoleName[];
  children: React.ReactNode;
  hideChild?: boolean; //parameter need only for hide something if admin added restrictions for "user" permissions
  RenderInstead?: JSX.Element | CustomComponent;
}

export const RoleComponentGuard: React.FC<RoleComponentGuardProps> = ({
  availableRoles,
  children,
  hideChild,
  RenderInstead
}): JSX.Element => {
  const role: IRole | null = useUserRoleSelector();
  const { name } = role || {};

  return useMemo(() => {
    if (hideChild) {
      return RenderInstead && typeof RenderInstead !== "function" ? RenderInstead : <></>;
    }

    if (typeof availableRoles === "string" && name === availableRoles) {
      return <>{children}</>;
    }

    if (name && isArray(availableRoles) && availableRoles.includes(name)) {
      return <>{children}</>;
    }

    if (RenderInstead && typeof RenderInstead === "function") {
      return <RenderInstead />;
    }

    if (RenderInstead && typeof RenderInstead !== "function") {
      return RenderInstead;
    }

    return <></>;
  }, [name, availableRoles, children, hideChild]);
};
